// extracted by mini-css-extract-plugin
export default {"wrapper":"documents_wrapper__GJBR3","documents":"documents_documents__KhTC3","document":"documents_document__QT9pi"};